import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Chat from './components/Chat';
import Terms from './components/Terms';
import { LoadingContext } from './components/loadingContext';
import LoadingScreen from './components/LoadingScreen';
import './App.css';
import Box from '@mui/material/Box';
import TitleUpdater from "./components/TitleUpdater"

function App() {

  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingScreen(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <TitleUpdater />
      {loadingScreen && <LoadingScreen />} {/* Muestra la pantalla de carga cuando loading es true */}
      <Routes>
        {/* Ruta para los términos y condiciones, aislada del resto */}
        <Route path="/terms" element={<Terms />} />
        {/* Ruta para el layout principal de la aplicación */}
        <Route path="*" element={
          <LoadingContext.Provider value={{ loading, setLoading }}>
            <Box className="conda-container">
              <div className="app">
                <Routes>
                  <Route path="/" element={<Chat setLoading={setLoading} loading={loading} loadingScreen={loadingScreen} />} />
                  <Route path="/mati" element={<Chat cvAssistantID={process.env.REACT_APP_MATI_CV_ASSISTANT} setLoading={setLoading} loading={loading} loadingScreen={loadingScreen} />} />
                  <Route path="/luana" element={<Chat cvAssistantID={process.env.REACT_APP_LUANA_CV_ASSISTANT} setLoading={setLoading} loading={loading} loadingScreen={loadingScreen} />} />
                  <Route path="/leandro" element={<Chat cvAssistantID={process.env.REACT_APP_LEANDRO_CV_ASSISTANT} setLoading={setLoading} loading={loading} loadingScreen={loadingScreen} />} />
                  <Route path="/:asstID" element={<Chat setLoading={setLoading} loading={loading} loadingScreen={loadingScreen} />} />
                </Routes>
              </div>
            </Box>
          </LoadingContext.Provider>
        } />
      </Routes>
    </Router>
  );
}

export default App;
